// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Offline_pageWrapper__FexCp","imgWrapper":"Offline_imgWrapper__jrycW","title":"Offline_title__ZsZIY","subtitle":"Offline_subtitle__8vFjw"};